import styled from "styled-components"

import { Color, TextSize, SpacingSize, RadiusSize, Transition } from "~/consts/style-mixins"

export const Container = styled.div`
  width: 100%;
  .title {
    display: flex;
  }
  .display-wrapper {
    margin: 0 0 0 ${SpacingSize.XS}px;
  }
  .pagination {
    display: flex;
    margin-top: ${SpacingSize.XS}px;
  }
  .pagination_item {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid ${Color.LightGray};
    border-radius: ${RadiusSize.Small}px;
    color: ${Color.LightGray};
    font-size: ${TextSize.XS}px;
    font-weight: bold;
    background: ${Color.White};
    ${Transition.Hover};
    svg {
      ${Transition.Hover};
    }
    &:not(:first-child) {
      margin-left: ${SpacingSize.XS}px;
    }
    &:hover {
      border: 1px solid ${Color.Gray};
      color: ${Color.Gray};
      background: ${Color.BackgroundGray};
      svg {
        fill: ${Color.Gray};
      }
    }
    &.current {
      border: 1px solid ${Color.Primary};
      color: ${Color.Primary};
      &:hover {
        border: 1px solid ${Color.Primary};
        color: ${Color.Primary};
        background: ${Color.White};
      }
    }
  }
  .dot {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    margin-left: ${SpacingSize.XS}px;
  }
`
